import { ComponentType } from 'react';

import { Dashboard } from '@ledium/ui-dashboard';
import { Groups, GroupsMainMenu } from '@ledium/ui-groups';
import { LightChannels, LightChannelsMainMenu } from '@ledium/ui-light-channels';
import { LightRecipes, LightRecipesMainMenu } from '@ledium/ui-light-recipes';
import { ProjectEditor, ProjectEditorMainMenu } from '@ledium/ui-project-editor';
import { RecipeEditor, RecipeEditorMainMenu } from '@ledium/ui-recipe-editor';
import { Settings } from '@ledium/ui-settings';
import { SpectrumMixer, SpectrumMixerMainMenu } from '@ledium/ui-spectrum-mixer';

export interface RouteConfig {
    pageName: string;
    path: string;
    Component: ComponentType;
    MenuComponent?: ComponentType;
}

export const routeConfig: RouteConfig[] = [
    {
        pageName: 'dashboard',
        path: '/',
        Component: Dashboard
    },
    {
        pageName: 'settings',
        path: '/settings/:tabName?',
        Component: Settings
    },
    {
        pageName: 'groups',
        path: '/groups/:pageType(new|edit|view)?/:itemId?',
        MenuComponent: GroupsMainMenu,
        Component: Groups
    },
    {
        pageName: 'lightChannels',
        path: '/light-channels/:pageType(new|edit|view)?/:itemId?',
        MenuComponent: LightChannelsMainMenu,
        Component: LightChannels
    },
    {
        pageName: 'spectrumMixers',
        path: '/spectrum-mixes/:pageType(new|edit|view)?/:itemId?',
        MenuComponent: SpectrumMixerMainMenu,
        Component: SpectrumMixer
    },
    {
        pageName: 'projects',
        path: '/projects/:pageType(new|edit|view)?/:itemId?',
        MenuComponent: ProjectEditorMainMenu,
        Component: ProjectEditor
    },
    {
        pageName: 'recipes',
        path: '/recipes/:pageType(new|edit|view)?/:itemId?',
        MenuComponent: RecipeEditorMainMenu,
        Component: RecipeEditor
    },
    {
        pageName: 'lightRecipes',
        path: '/light-recipes/:pageType(new|edit|view)?/:itemId?',
        MenuComponent: LightRecipesMainMenu,
        Component: LightRecipes
    }
];
